export const fetchLineChartData = async (request, payload) => {
try {
        const response = await request("POST", `/v1/survey/charts/line`,{ data: payload }, "survey_service");
        return response;

    } catch (error) {
        console.log(error)
    }

};

export const lineChartData = {
    "total": 400,
    "data": [
        {
            "name": "2019-01-01",
            "value": 10
        },
        {
            "name": "2020-01-01",
            "value": 193
        },
        {
            "name": "2022-01-01",
            "value": 121
        },
        {
            "name": "2025-01-01",
            "value": 76
        }
    ]
}